import { render, staticRenderFns } from "./CalendarField.vue?vue&type=template&id=8b08c2f2"
import script from "./CalendarField.vue?vue&type=script&lang=js"
export * from "./CalendarField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports